export function partition<T>(
  items: T[],
  condition: (item: T) => boolean,
): [T[], T[]] {
  return items.reduce(
    ([truthy, falsy], element) => {
      if (condition(element)) {
        truthy.push(element);
      } else {
        falsy.push(element);
      }
      return [truthy, falsy];
    },
    [[], []] as [T[], T[]],
  );
}

export function mapBy<T>(
  items: T[],
  keyFn: (item: T) => string,
): { [key: string]: T } {
  return items.reduce((acc, item) => {
    acc[keyFn(item)] = item;
    return acc;
  }, {} as { [key: string]: T });
}
